import { render, staticRenderFns } from "./VerCaja.vue?vue&type=template&id=5f51e941&scoped=true&"
import script from "./VerCaja.vue?vue&type=script&lang=js&"
export * from "./VerCaja.vue?vue&type=script&lang=js&"
import style0 from "./VerCaja.vue?vue&type=style&index=0&id=5f51e941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51e941",
  null
  
)

export default component.exports